"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTimeFormatter = getDateTimeFormatter;
const constants_js_1 = require("../../constants.js");
function getDateTimeFormatter(intlFormatters) {
    return (date) => intlFormatters.formatDate(date, constants_js_1.dateTimeFormat);
}
//# sourceMappingURL=getDateTimeFormatter.js.map